import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/customer/multiSession/customer.multiSession.mutation.gql"
import type {
  CustomerMultiSessionMutation,
  CustomerMultiSessionMutationVariables,
} from "@/v2-backoffice-client/customer/multiSession/__types__/customer.multiSession.mutation"

type Options = MutationHookOptions<
  CustomerMultiSessionMutation,
  CustomerMultiSessionMutationVariables
>

export function useCustomerMultiSessionMutation(options?: Options) {
  return useMutation<
    CustomerMultiSessionMutation,
    CustomerMultiSessionMutationVariables
  >(mutation, options)
}
